import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Button,
  Dropdown,
  DropdownButton,
  Modal,
  Form,
} from "react-bootstrap";
import InputField from "./InputfieldSales";
import axios from "axios";
import { AiOutlinePlus } from "react-icons/ai";
import baseURL from "../../../../Url/NodeBaseURL";
import { useNavigate, useLocation } from "react-router-dom";
import { FaTrash, FaCamera, FaUpload } from "react-icons/fa";
import Webcam from "react-webcam";
import "./SalesForm.css";

const ProductDetails = ({
  fromOrd,
  EstimateNo,
  handleAdd,
  handleUpdate,
  isEditing,
  formData,
  setFormData,
  data,
  handleChange,
  handleImageChange,
  fileInputRef,
  clearImage,
  captureImage,
  setShowWebcam,
  showWebcam,
  webcamRef,
  setShowOptions,
  showOptions,
  handleBarcodeChange,
  handleProductNameChange,
  handleMetalTypeChange,
  handleDesignNameChange,
  products,
  filteredDesignOptions,
  filteredPurityOptions,
  filteredMetalTypes,
  categoryOptions,
  subcategoryOptions,
  designOptions,
  uniqueProducts,
  purityOptions,
  metaltypeOptions,
  isBarcodeSelected,
  isQtyEditable,
  estimate,
  selectedEstimate,
  handleEstimateChange,
  refreshSalesData,
  fetchCategory,
  fetchSubCategory,
  taxableAmount,
  setIsTotalPriceCleared,
  isManualTotalPriceChange,
  setIsManualTotalPriceChange,
  offers,
  handleOrderChange,
  selectedOrder,
  orderData,
}) => {
  const [showModal, setShowModal] = useState(false);
  const isByFixed = formData.pricing === "By fixed";
  const navigate = useNavigate();
  const location = useLocation();
  const orderDetails = location.state?.orderDetails || [];
  //const [selectedEstimate, setSelectedEstimate] = useState("");
  const [productList, setProductList] = useState([]);

  const defaultBarcode = formData.category
    ? products.find((product) => product.product_name === formData.category)
        ?.rbarcode || ""
    : "";

  // Generate options list for barcode selection
  const barcodeOptions = [
    ...products.map((product) => ({
      value: product.rbarcode,
      label: product.rbarcode,
    })),
    ...data.map((tag) => ({
      value: tag.PCode_BarCode,
      label: tag.PCode_BarCode,
    })),
  ];

  // Ensure default barcode is included in options
  if (
    defaultBarcode &&
    !barcodeOptions.some((option) => option.value === defaultBarcode)
  ) {
    barcodeOptions.unshift({ value: defaultBarcode, label: defaultBarcode });
  }

  // Set default barcode only if formData.code is empty
  useEffect(() => {
    if (!formData.code && defaultBarcode) {
      handleBarcodeChange(defaultBarcode);
    }
  }, [formData.category, defaultBarcode]);

  function isCurrentDate(dateString) {
    const today = new Date();
    const date = new Date(dateString);

    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }
  const isToday = isCurrentDate(formData.date);
  const isTagEntryProduct =
    !!formData.opentag_id &&
    String(formData.opentag_id).trim() !== "" &&
    String(formData.opentag_id).trim().toLowerCase() !== "null";
  const isRunningTag = formData.pricing === "By Running Tag";
  const showTagBalance =
    isTagEntryProduct &&
    isRunningTag &&
    (String(formData.tag_balance_pcs || "").trim() !== "" ||
      String(formData.tag_balance_weight || "").trim() !== "");

  useEffect(() => {
    if (orderDetails.length > 0) {
      const item = orderDetails[0];
      setFormData({
        // Customer fields
        customer_id: item.customer_id,
        account_name: item.account_name,
        mobile: item.mobile,
        email: item.email,
        address1: item.address1,
        address2: item.address2,
        city: item.city,
        pincode: item.pincode,
        state: item.state,
        state_code: item.state_code,
        aadhar_card: item.aadhar_card,
        gst_in: item.gst_in,
        date:
          item.date ??
          new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" }),
        pan_card: item.pan_card,
        // Product fields
        category: item.category,
        code: item.code,
        metal_type: item.metal_type,
        product_name: item.product_name,
        design_name: item.design_name,
        pricing: item.pricing,
        pricingOpt: item.pricingOpt,
        selling_purity: item.selling_purity,
        custom_purity: item.custom_purity ?? "",
        purity: item.purity,
        gross_weight: item.gross_weight,
        stone_weight: item.stone_weight,
        stone_price: item.stone_price,
        weight_bw: item.weight_bw,
        va_on: item.va_on,
        va_percent: item.va_percent,
        wastage_weight: item.wastage_weight,
        total_weight_av: item.total_weight_av,
        size: item.size,
        rate: item.rate,
        rate_amt: item.rate_amt,
        mc_on: item.mc_on,
        mc_per_gram: item.mc_per_gram,
        making_charges: item.making_charges,
        hm_charges: item.hm_charges,
        tax_percent: item.tax_percent,
        tax_amt: item.tax_amt,
        total_price: item.total_price,
        remarks: item.remarks,
        qty: item.qty,
        imagePreview: item.imagePreview,
        client_visibility: "Internal Facing",
      });
    }
  }, [orderDetails]);

  // State to store full subcategory data for "By Running Tag" products
  const [selectedSubcategoryData, setSelectedSubcategoryData] = useState(null);

  // Fetch full subcategory details when product_name changes and pricing is "By Running Tag"
  useEffect(() => {
    const fetchSubcategoryDetails = async () => {
      if (!formData.product_name || formData.pricing !== "By Running Tag") {
        setSelectedSubcategoryData(null);
        return;
      }

      try {
        // Fetch all subcategories to find the one matching product_name
        const response = await axios.get(`${baseURL}/subcategory`);
        const allSubcategories = response.data?.data || [];
        
        const selectedSubCategory = allSubcategories.find(
          (cat) => cat.sub_category_name === formData.product_name
        );

        if (selectedSubCategory && selectedSubCategory.subcategory_id) {
          const detailResponse = await axios.get(
            `${baseURL}/subcategory/${selectedSubCategory.subcategory_id}`
          );
          setSelectedSubcategoryData(detailResponse.data);
        }
      } catch (error) {
        console.error("Error fetching subcategory details:", error);
        setSelectedSubcategoryData(null);
      }
    };

    fetchSubcategoryDetails();
  }, [formData.product_name, formData.pricing]);

  // Calculate selling purity for "By Running Tag" products
  const calculateSellingPurityForRunningTag = useCallback(() => {
    if (formData.pricing !== "By Running Tag") {
      return null;
    }

    const parsePercent = (val) => {
      if (val === null || val === undefined || val === "") return 0;
      const s = val.toString().replace("%", "").trim();
      const n = Number(s);
      return Number.isFinite(n) ? n : 0;
    };

    // Get current tag data if it's a tag entry product
    const currentTag = isTagEntryProduct && formData.code
      ? data.find((tag) => String(tag.PCode_BarCode) === String(formData.code))
      : null;

    // Get purchase purity - prioritize formData (set from barcode scan), then tag data, then subcategory
    let purchasePuritySource = formData.pur_purityPercentage || formData.purchase_manual_purity;
    
    // If formData has pur_Purity, check if it's "Manual"
    if (!purchasePuritySource && formData.pur_Purity) {
      if (String(formData.pur_Purity).toLowerCase().includes("manual")) {
        purchasePuritySource = formData.pur_purityPercentage;
      } else {
        purchasePuritySource = formData.pur_Purity;
      }
    }
    
    // Fallback to tag or subcategory
    if (!purchasePuritySource) {
      purchasePuritySource = currentTag?.pur_purityPercentage || 
        currentTag?.pur_Purity ||
      selectedSubcategoryData?.purchase_manual_purity ||
        "";
    }
    
    const purchasePurity = parsePercent(purchasePuritySource);

    // Get purchase MC% (only if MC On is "MC %")
    let purchaseMC = 0;
    const mcOnValue = formData.pur_Making_Charges_On || formData.mc_on || currentTag?.pur_Making_Charges_On || "";
    
    if (mcOnValue === "MC %" || formData.pur_MC_Per_Gram || currentTag?.pur_MC_Per_Gram) {
      const mcSource = formData.pur_MC_Per_Gram ||
        formData.purchase_mc_percent ||
        currentTag?.pur_MC_Per_Gram ||
        selectedSubcategoryData?.purchase_mc_percent ||
        "";
      purchaseMC = parsePercent(mcSource);
    }

    // Get purchase wastage%
    const purchaseWastageSource = formData.pur_Wastage_Percentage ||
      formData.purchase_wastage_percent ||
      currentTag?.pur_Wastage_Percentage ||
      selectedSubcategoryData?.purchase_wastage_percent ||
      "";
    const purchaseWastage = parsePercent(purchaseWastageSource);

    // Get selling addon purity - check formData, then subcategory
    const sellingAddonPuritySource = formData.selling_addon_purity ||
      selectedSubcategoryData?.selling_addon_purity ||
      "";
    const sellingAddonPurity = parsePercent(sellingAddonPuritySource);

    // Get selling addon MC%
    const sellingAddonMCSource = formData.selling_addon_mc_percent ||
      selectedSubcategoryData?.selling_addon_mc_percent ||
      "";
    const sellingAddonMC = parsePercent(sellingAddonMCSource);

    // Get selling addon wastage%
    const sellingAddonWastageSource = formData.selling_addon_wastage_percent ||
      selectedSubcategoryData?.selling_addon_wastage_percent ||
      "";
    const sellingAddonWastage = parsePercent(sellingAddonWastageSource);

    // Selling Purity = Purchase Purity + Selling Addon Purity only
    // MC and Wastage are shown separately in their own fields (MC % and Wastage %)
    const totalPurity = purchasePurity + sellingAddonPurity;
    
    const result = totalPurity > 0 ? totalPurity.toFixed(2) : null;
    return result;
  }, [
    formData.pricing,
    formData.code,
    formData.pur_purityPercentage,
    formData.purchase_manual_purity,
    formData.mc_on,
    formData.pur_MC_Per_Gram,
    formData.purchase_mc_percent,
    formData.pur_Wastage_Percentage,
    formData.purchase_wastage_percent,
    formData.selling_addon_purity,
    formData.selling_addon_mc_percent,
    formData.selling_addon_wastage_percent,
    isTagEntryProduct,
    data,
    selectedSubcategoryData,
  ]);

  // Calculate rate based on selling purity
  useEffect(() => {
    if (formData.pricing === "By Running Tag") {
      const calculatedPurity = calculateSellingPurityForRunningTag();
      if (calculatedPurity) {
        const purityValue = parseFloat(calculatedPurity);
        const metalType = (formData.metal_type || "").toLowerCase();
        
        // Get base 24k rate (this should come from rates state or formData)
        const base24Rate = metalType.includes("silver")
          ? parseFloat(formData.rate_24k) || 0
          : parseFloat(formData.rate_24k) || 0;
        
        if (purityValue > 0 && base24Rate > 0) {
          const calculatedRate = ((purityValue / 100) * base24Rate).toFixed(2);
          
          setFormData((prev) => {
            if (prev.rate !== calculatedRate) {
              return {
                ...prev,
                rate: calculatedRate,
                custom_purity: calculatedPurity,
                selling_purity: "Manual",
              };
            }
            return prev;
          });
        }
      }
    }
  }, [
    formData.pricing,
    formData.product_name,
    formData.metal_type,
    formData.rate_24k,
    formData.code,
    formData.pur_purityPercentage,
    formData.pur_MC_Per_Gram,
    formData.pur_Wastage_Percentage,
    formData.selling_addon_purity,
    formData.selling_addon_mc_percent,
    formData.selling_addon_wastage_percent,
    formData.mc_on,
    selectedSubcategoryData,
    data,
    isTagEntryProduct,
    calculateSellingPurityForRunningTag,
    setFormData,
  ]);

  const handleClear = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      code: "",
      product_id: "",
      metal: "",
      product_name: "",
      metal_type: "",
      design_name: "",
      purity: "",
      pricing: "By Weight",
      pricingOpt: "Net Weight",
      category: "",
      sub_category: "",
      gross_weight: "",
      stone_weight: "",
      weight_bw: "",
      stone_price: "",
      va_on: "Gross Weight",
      va_percent: "",
      wastage_weight: "",
      total_weight_av: "",
      mc_on: "MC %",
      disscount_percentage: "",
      disscount: "",
      mc_per_gram: "",
      making_charges: "",
      rate: "",
      // rate_24k: "",
      pieace_cost: "",
      mrp_price: "",
      rate_amt: "",
      tax_percent: "03% GST",
      tax_amt: "",
      hm_charges: "60.00",
      total_price: "",
      transaction_status: "Sales",
      qty: "1",
      opentag_id: "",
      product_image: null,
      imagePreview: null,
      remarks: "",
      sale_status: "Delivered",
      custom_purity: "",
      client_visibility: "Internal Facing",
      tag_balance_pcs: "",
      tag_balance_weight: "",
    }));
  };

  useEffect(() => {
    const grossWeight = parseFloat(formData.gross_weight) || 0;
    const stoneWeight = parseFloat(formData.stone_weight) || 0;
    const stonePrice = parseFloat(formData.stone_price) || 0;
    const vaPercent = parseFloat(formData.va_percent) || 0;
    const rate = parseFloat(formData.rate) || 0;
    const mcPerGram = parseFloat(formData.mc_per_gram) || 0;
    const hmCharges = parseFloat(formData.hm_charges) || 0;
    const taxPercent = parseFloat(formData.tax_percent) || 0;
    const discount = parseFloat(formData.disscount) || 0;
    const festivalDiscount = parseFloat(formData.festival_discount) || 0;
    const qty = parseFloat(formData.qty) || 0;
    const pieceCost = parseFloat(formData.pieace_cost) || 0;
    const pricingOpt = parseFloat(formData.pricingOpt) || 0;

    const baseWeight =
      pricingOpt === "Net Weight" ? grossWeight - stoneWeight : grossWeight;
    // Weight BW
    const weightBW = grossWeight - stoneWeight;

    // Wastage Weight
    const wastageWeight =
      formData.va_on === "Gross Weight"
        ? (grossWeight * vaPercent) / 100
        : (weightBW * vaPercent) / 100;

    // Total Weight AW
    const totalWeightAW = baseWeight + wastageWeight;

    // Rate Amount
    let rateAmt = 0;
    if (formData.pricing === "By fixed" || formData.pricing === "By Running Tag") {
      rateAmt = pieceCost * qty;
    } else {
      rateAmt = rate * totalWeightAW;
    }

    // Making Charges
    let makingCharges = 0;
    let calculatedMcPerGram = null;

    if (formData.mc_on === "MC %") {
      makingCharges = (mcPerGram * rateAmt) / 100;
    } else if (formData.mc_on === "MC / Gram") {
      makingCharges = mcPerGram * totalWeightAW;
    } else if (formData.mc_on === "MC / Piece") {
      const pieceMakingCharges = parseFloat(formData.making_charges) || 0;
      if (pieceMakingCharges && totalWeightAW > 0) {
        calculatedMcPerGram = pieceMakingCharges / totalWeightAW;
        makingCharges = pieceMakingCharges;
      }
    } else {
      makingCharges = parseFloat(formData.making_charges) || 0;
    }

    // Taxable Amount & Tax
    let taxAmt = 0;
    let totalPrice = 0;

    if (formData.pricing === "By fixed" || formData.pricing === "By Running Tag") {
      const taxable = pieceCost * qty;
      taxAmt = (taxPercent * taxable) / 100;
      totalPrice = taxable + taxAmt;

      setFormData((prev) => ({
        ...prev,
        piece_taxable_amt: taxable.toFixed(2),
        tax_amt: taxAmt.toFixed(2),
        mrp_price: (totalPrice / qty).toFixed(2),
        total_price: totalPrice.toFixed(2),
      }));
    } else {
      const totalDiscount = discount + festivalDiscount;
      const taxable =
        rateAmt + stonePrice + makingCharges + hmCharges - totalDiscount;
      taxAmt = (taxable * taxPercent) / 100;
      totalPrice = taxable + taxAmt;

      // setFormData(prev => ({
      //   ...prev,
      //   tax_amt: taxAmt.toFixed(2),
      //   total_price: totalPrice.toFixed(2),
      // }));
      setFormData((prev) => {
        const roundedTaxAmt = parseFloat(taxAmt).toFixed(2);
        const roundedTotalPrice = (
          Math.round(parseFloat(totalPrice) * 100) / 100
        ).toFixed(2);

        return {
          ...prev,
          tax_amt: taxAmt.toFixed(2),
          total_price: roundedTotalPrice,
        };
      });
    }

    // Final shared state update
    setFormData((prev) => ({
      ...prev,
      weight_bw: weightBW.toFixed(2),
      wastage_weight: wastageWeight.toFixed(2),
      total_weight_av: totalWeightAW.toFixed(2),
      rate_amt: rateAmt.toFixed(2),
      making_charges: makingCharges.toFixed(2),
      ...(calculatedMcPerGram !== null && {
        mc_per_gram: calculatedMcPerGram.toFixed(2),
      }),
    }));
  }, [
    formData.gross_weight,
    formData.stone_weight,
    formData.stone_price,
    formData.va_percent,
    formData.va_on,
    formData.rate,
    formData.mc_on,
    formData.mc_per_gram,
    formData.making_charges,
    formData.hm_charges,
    formData.tax_percent,
    formData.disscount,
    formData.festival_discount,
    formData.qty,
    formData.pieace_cost,
    formData.pricing,
    formData.pricingOpt,
  ]);

  useEffect(() => {
    if (!offers || offers.length === 0) return;

    const selectedOffer = offers[0]; // Assuming auto-apply first offer
    const percentageDiscount =
      parseFloat(selectedOffer.discount_percentage) || 0;
    const rateDiscount = parseFloat(selectedOffer.discount_on_rate) || 0;
    const fixedPercentageDiscount =
      parseFloat(selectedOffer.discount_percent_fixed) || 0;

    const taxPercent = parseFloat(formData.tax_percent) || 1;
    const pieceCost = parseFloat(formData.pieace_cost) || 0;
    const qty = parseFloat(formData.qty) || 1;
    const rateAmt = parseFloat(formData.rate_amt) || 0;
    const stonePrice = parseFloat(formData.stone_price) || 0;
    const makingCharges = parseFloat(formData.making_charges) || 0;
    const hmCharges = parseFloat(formData.hm_charges) || 0;
    const grossWeight = parseFloat(formData.gross_weight) || 0;
    const discountAmt = parseFloat(formData.disscount) || 0;

    if (formData.pricing === "By fixed" || formData.pricing === "By Running Tag") {
      const pieceTaxableAmt = pieceCost * qty;
      // const originalPieceTaxableAmt = formData.original_piece_taxable_amt
      //   ? parseFloat(formData.original_piece_taxable_amt)
      //   : pieceTaxableAmt;

      const originalPieceTaxableAmt = formData.original_piece_taxable_amt
        ? parseFloat(formData.original_piece_taxable_amt)
        : pieceTaxableAmt;

      const calculatedDiscount =
        (pieceTaxableAmt * fixedPercentageDiscount) / 100;
      const updatedPieceTaxableAmt = pieceTaxableAmt - calculatedDiscount;
      const taxAmt = (taxPercent * updatedPieceTaxableAmt) / 100;
      const totalPrice = updatedPieceTaxableAmt + taxAmt;

      setFormData((prev) => ({
        ...prev,
        original_piece_taxable_amt: pieceTaxableAmt.toFixed(2),
        festival_discount: calculatedDiscount.toFixed(2),
        festival_discount_percentage: percentageDiscount.toFixed(2),
        festival_discount_on_rate: rateDiscount.toFixed(2),
        piece_taxable_amt: updatedPieceTaxableAmt.toFixed(2),
        tax_amt: taxAmt.toFixed(2),
        total_price: totalPrice.toFixed(2),
      }));
    } else {
      const weightBasedDiscount = (rateDiscount / 10) * grossWeight;
      const calculatedDiscount =
        (makingCharges * percentageDiscount) / 100 + weightBasedDiscount;
      const totalBeforeTax =
        rateAmt +
        stonePrice +
        makingCharges +
        hmCharges -
        calculatedDiscount -
        discountAmt;

      const taxAmt = (totalBeforeTax * taxPercent) / 100;
      const totalPrice = totalBeforeTax + taxAmt;

      setFormData((prev) => ({
        ...prev,
        original_total_price: formData.original_total_price
          ? formData.original_total_price
          : parseFloat(formData.total_price || 0).toFixed(2),
        festival_discount: calculatedDiscount.toFixed(2),
        festival_discount_percentage: percentageDiscount.toFixed(2),
        festival_discount_on_rate: rateDiscount.toFixed(2),
        tax_amt: taxAmt.toFixed(2),
        total_price: totalPrice.toFixed(2),
      }));
    }
  }, [
    formData.pricing,
    formData.tax_percent,
    formData.pieace_cost,
    formData.qty,
    formData.rate_amt,
    formData.stone_price,
    formData.making_charges,
    formData.hm_charges,
    formData.gross_weight,
    formData.disscount,
    formData.original_total_price,
    formData.original_piece_taxable_amt,
    offers,
  ]);

  const handleTotalPriceChange = () => {
    if (!offers || offers.length === 0) return;

    const selectedOffer = offers[0]; // Assuming auto-apply first offer
    const percentageDiscount =
      parseFloat(selectedOffer.discount_percentage) || 0;
    const rateDiscount = parseFloat(selectedOffer.discount_on_rate) || 0;
    const fixedPercentageDiscount =
      parseFloat(selectedOffer.discount_percent_fixed) || 0;

    const totalPrice = parseFloat(formData.total_price);
    const taxPercent = parseFloat(formData.tax_percent) || 0;
    const rateAmt = parseFloat(formData.rate_amt) || 0;
    const hmCharges = parseFloat(formData.hm_charges) || 0;
    const stonePrice = parseFloat(formData.stone_price) || 0;
    const discount = parseFloat(formData.disscount) || 0;
    const festivalDiscount = parseFloat(formData.festival_discount) || 0;
    const totalWeightAW = parseFloat(formData.total_weight_av) || 0;
    const makingChargesInput = parseFloat(formData.making_charges) || 0;
    const grossWeight = parseFloat(formData.gross_weight) || 0;

    let mcPerGram = 0;

    if (
      !isNaN(totalPrice) &&
      totalPrice > 0 &&
      taxPercent > 0 &&
      rateAmt > 0 &&
      100 - percentageDiscount !== 0
    ) {
      const taxableAmount = (totalPrice * 100) / (100 + taxPercent);

      if (formData.mc_on === "MC %") {
        const weightBasedDiscount = (rateDiscount / 10) * grossWeight;

        const mcPerGramNumerator =
          totalPrice / (1 + taxPercent / 100) -
          rateAmt -
          hmCharges +
          weightBasedDiscount;

        const mcPerGramDenominator = rateAmt * (100 - percentageDiscount);

        mcPerGram = (mcPerGramNumerator * 10000) / mcPerGramDenominator;
      } else if (
        formData.mc_on === "MC / Gram" ||
        formData.mc_on === "MC / Piece"
      ) {
        // Reverse calculate mcPerGram from TotalMC

        // TotalMC = taxableAmount - rateAmt - hmCharges - stonePrice + discount + festivalDiscount
        const weightBasedDiscount = (rateDiscount / 10) * grossWeight;
        const adjustedFestivalDiscount =
          (percentageDiscount / 100) * makingChargesInput + weightBasedDiscount;

        const totalMC =
          taxableAmount -
          rateAmt -
          hmCharges -
          stonePrice +
          discount +
          adjustedFestivalDiscount;

        if (totalWeightAW > 0) {
          mcPerGram = totalMC / totalWeightAW;
        }
      } else {
        mcPerGram = parseFloat(formData.mc_per_gram) || 0;
      }

      if (!isNaN(mcPerGram)) {
        setFormData((prev) => ({
          ...prev,
          mc_per_gram: mcPerGram,
        }));
      }
    }
    setIsManualTotalPriceChange(false);
  };

  const validateFields = () => {
    const errors = [];

    // Validate Barcode/Rbarcode
    if (!formData.code || formData.code.trim() === "") {
      errors.push("BarCode/Rbarcode is required");
    }

    // Validate Gross Weight for "By Weight" pricing
    if (formData.pricing !== "By fixed" && formData.pricing !== "By Running Tag") {
      if (!formData.gross_weight || parseFloat(formData.gross_weight) <= 0) {
        errors.push("Gross Weight is required and must be greater than 0");
      }
    }

    if (errors.length > 0) {
      alert(errors.join("\n"));
      return false;
    }

    return true;
  };

  const handleAddWithValidation = () => {
    if (validateFields()) {
      handleAdd();
    }
  };

  const handleUpdateWithValidation = () => {
    if (validateFields()) {
      handleUpdate();
    }
  };

  return (
    <Col>
      <Row>
        {/* <Col xs={12} md={2}>
          <InputField
            label="BarCode/Rbarcode"
            name="code"
            value={formData.code || ""}
            onChange={(e) => handleBarcodeChange(e.target.value)}
            type="select"
            options={barcodeOptions.filter(option =>
              // Filter barcodes based on selected category if one is selected
              !formData.category ||
              products.some(prod =>
                prod.rbarcode === option.value &&
                prod.product_name === formData.category
              )
            )}
            autoFocus
          />
        </Col> */}

        <Col xs={12} md={2}>
          <InputField
            label="BarCode/Rbarcode"
            name="code"
            value={formData.code || defaultBarcode} // Default barcode when formData.code is empty
            onChange={(e) => handleBarcodeChange(e.target.value)}
            type="select"
            options={barcodeOptions}
            autoFocus
            disabled={!isToday || fromOrd}
          />
        </Col>

        <Col xs={12} md={2} className="d-flex align-items-center">
          <div style={{ flex: 1 }}>
            <InputField
              label="Category"
              name="category"
              value={formData.category || ""}
              type="select"
              onChange={handleChange}
              options={categoryOptions}
              disabled={!isToday || fromOrd || isTagEntryProduct}
            />
          </div>
          <AiOutlinePlus
            size={20}
            color="black"
            style={{
              marginLeft: "10px",
              cursor: isTagEntryProduct ? "not-allowed" : "pointer",
              marginBottom: "20px",
              opacity: isTagEntryProduct ? 0.5 : 1,
            }}
            onClick={() =>
              !isTagEntryProduct && navigate("/itemmaster", {
                state: {
                  from: `/sales`,
                },
              })
            }
          />
        </Col>

        <Col xs={12} md={2}>
          <InputField
            label="Metal Type"
            name="metal_type"
            value={formData.metal_type || ""}
            onChange={handleChange}
            type="select"
            options={metaltypeOptions}
            disabled={!isToday || fromOrd || isTagEntryProduct}
          />
        </Col>
        <Col xs={12} md={2} className="d-flex align-items-center">
          <div style={{ flex: 1 }}>
            <InputField
              label="Sub Category"
              name="product_name"
              value={formData.product_name || ""}
              onChange={handleChange}
              type="select"
              options={subcategoryOptions}
              disabled={!isToday || fromOrd || isTagEntryProduct}
            />
          </div>
          <AiOutlinePlus
            size={20}
            color="black"
            style={{
              marginLeft: "10px",
              cursor: isTagEntryProduct ? "not-allowed" : "pointer",
              marginBottom: "20px",
              opacity: isTagEntryProduct ? 0.5 : 1,
            }}
            // onClick={() => navigate("/subcategory", { state: { from: "/sales" } })}
            onClick={() =>
              !isTagEntryProduct && navigate("/subcategoryv2", {
                state: { orderDetails: [formData], from: "/sales" },
              })
            }
          />
        </Col>

        <Col xs={12} md={2}>
          <InputField
            label="Product Design Name"
            name="design_name"
            value={formData.design_name}
            onChange={handleChange}
            type="select"
            options={designOptions}
            disabled={!isToday || fromOrd || isTagEntryProduct}
          />
        </Col>

        <Col xs={12} md={2}>
          <InputField
            label="Pricing"
            name="pricing"
            type="select"
            value={formData.pricing || ""} // Default to "Gross Weight"
            onChange={handleChange}
            options={[
              { value: "By Weight", label: "By Weight" },
              { value: "By fixed", label: "By fixed" },
              { value: "By Running Tag", label: "By Running Tag" },
              ...(formData.pricing &&
              !["By Weight", "By fixed", "By Running Tag"].includes(formData.pricing)
                ? [{ value: formData.pricing, label: formData.pricing }]
                : []),
            ]}
            disabled={!isToday || fromOrd || isTagEntryProduct}
          />
        </Col>

        {/* Render different fields based on Pricing selection */}
        {isByFixed ? (
          // If Pricing is "By fixed", show only these fields:
          <>
            <Col xs={12} md={2}>
              <InputField
                label="Printing Purity"
                name="printing_purity"
                value={formData.printing_purity || ""}
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            {/* <Col xs={12} md={1}>
              <InputField
                label="Gross Wt"
                name="gross_weight"
                value={formData.gross_weight || ""}
                onChange={handleChange}
              />
            </Col> */}
            {/* <Col xs={12} md={1}>
              <InputField
                label="Rate"
                name="rate"
                value={formData.rate}
                onChange={handleChange}
              />
            </Col> */}
            <Col xs={12} md={2}>
              <InputField
                label="Piece Cost"
                name="pieace_cost"
                value={formData.pieace_cost}
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>

            <Col xs={12} md={1}>
              <InputField
                label="Qty"
                name="qty"
                value={formData.qty}
                onChange={handleChange}
                readOnly={isQtyEditable}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={2}>
              <InputField
                label="Taxable Amt"
                name="piece_taxable_amt"
                value={formData.piece_taxable_amt}
                onChange={handleChange}
                readOnly
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>

            <Col xs={12} md={1}>
              <InputField
                label="Tax%"
                name="tax_percent"
                value={formData.tax_percent}
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={1}>
              <InputField
                label="Tax Amt"
                name="tax_amt"
                value={formData.tax_amt || "0.00"} // Default to "0.00" if undefined
                onChange={handleChange} // Optional, since it's auto-calculated
                readOnly
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={1}>
              <InputField
                label="MRP"
                name="mrp_price"
                value={formData.mrp_price || "0.00"} // Default to "0.00" if undefined
                onChange={handleChange} // Trigger recalculation of Total MC
                readOnly={false} // Ensure it's editable
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={2}>
              <InputField
                label="Total Price"
                name="total_price"
                disabled={!isToday || fromOrd || isTagEntryProduct}
                value={formData.total_price || "0.00"} // Default to "0.00" if undefined
                onChange={handleChange} // Optional, since it's auto-calculated
                readOnly
              />
            </Col>
            <Col xs={12} md={2}>
              <InputField
                label="Remarks"
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
              />
            </Col>
            <Col xs={12} md={2}>
              <InputField
                label="Visibility"
                name="client_visibility"
                disabled={!isToday || fromOrd || isTagEntryProduct}
                value={formData.client_visibility || "Internal Facing"}
                onChange={handleChange}
                type="select"
                options={[
                  { value: "Client Facing", label: "Client Facing" },
                  { value: "Internal Facing", label: "Internal Facing" },
                ]}
              />
            </Col>
            <Col xs={12} md={2}>
              <InputField
                label="Status"
                type="select"
                disabled={!isToday || fromOrd || isTagEntryProduct}
                name="sale_status"
                value={formData.sale_status}
                onChange={handleChange}
                options={[
                  { value: "Delivered", label: "Delivered" },
                  { value: "Not Delivered", label: "Not Delivered" },
                ]}
              />
            </Col>
            {/* <Col xs={12} md={2}>
              <InputField
                label="Upload Image"
                name="image"
                type="file"
                onChange={handleImageChange}
                accept="image/*"
                ref={fileInputRef} // Attach ref to input field
              />
              {formData.imagePreview && (
                <div style={{ position: "relative", display: "inline-block" }}>
                  <img
                    src={formData.imagePreview}
                    alt="Selected"
                    style={{
                      width: "100px",
                      height: "100px",
                      marginTop: "10px",
                      borderRadius: "8px", // Optional: add rounded corners to the image
                    }}
                  />
                  <button
                    type="button"
                    onClick={clearImage}
                    disabled={isTagEntryProduct}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "transparent",
                      border: "none",
                      color: "red",
                      fontSize: "16px",
                      cursor: isTagEntryProduct ? "not-allowed" : "pointer",
                      opacity: isTagEntryProduct ? 0.5 : 1,
                      zIndex: 10,
                    }}
                  >
                    <FaTrash />
                  </button>
                </div>
              )}
            </Col> */}
            <Col xs={12} md={2}>
              <DropdownButton
                id="dropdown-basic-button"
                title="Choose / Capture Image"
                variant="primary"
                size="sm"
                disabled={isTagEntryProduct}
                onClick={() => !isTagEntryProduct && setShowOptions(!showOptions)}
              >
                {showOptions && (
                  <>
                    <Dropdown.Item
                      onClick={() =>
                        !isTagEntryProduct && fileInputRef.current && fileInputRef.current.click()
                      }
                      disabled={isTagEntryProduct}
                    >
                      <FaUpload /> Choose Image
                    </Dropdown.Item>
                    <Dropdown.Item 
                      onClick={() => !isTagEntryProduct && setShowWebcam(true)}
                      disabled={isTagEntryProduct}
                    >
                      <FaCamera /> Capture Image
                    </Dropdown.Item>
                  </>
                )}
              </DropdownButton>

              {/* Hidden File Input */}
              <input
                type="file"
                name="image"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleImageChange}
                disabled={isTagEntryProduct}
              />

              {/* Webcam Section */}
              {showWebcam && (
                <div>
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    width={150}
                    height={150}
                  />
                  <Button
                    type="button"
                    variant="success"
                    size="sm"
                    onClick={captureImage}
                    style={{ marginRight: "5px" }}
                  >
                    Capture
                  </Button>
                  <Button
                    type="button"
                    variant="secondary"
                    size="sm"
                    onClick={() => setShowWebcam(false)}
                  >
                    Cancel
                  </Button>
                </div>
              )}
              {/* Image Preview */}
              {formData.imagePreview && (
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    marginTop: "10px",
                  }}
                >
                  <img
                    src={formData.imagePreview}
                    alt="Selected"
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "8px",
                    }}
                  />
                  <button
                    type="button"
                    onClick={clearImage}
                    disabled={isTagEntryProduct}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "transparent",
                      border: "none",
                      color: "red",
                      fontSize: "16px",
                      cursor: isTagEntryProduct ? "not-allowed" : "pointer",
                      opacity: isTagEntryProduct ? 0.5 : 1,
                      zIndex: 10,
                    }}
                  >
                    <FaTrash />
                  </button>
                </div>
              )}
            </Col>
          </>
        ) : (
          // Otherwise (if Pricing is not "By fixed"), show all fields:
          <>
            {/* <Col xs={12} md={2}>
              <InputField
                label="Purity"
                name="purity"
                value={formData.purity || ""}
                onChange={handleChange}
                type="select"
                options={purityOptions}
              />
            </Col> */}
            {/* <Col xs={12} md={2}>
              <InputField
                label="Purity"
                name="purity"
                value={formData.purity || ""}
                onChange={handleChange}
              // type="select"
              // options={purityOptions}
              />
            </Col> */}
            <Col xs={12} md={2}>
              {isRunningTag ? (
                <InputField
                  label="Selling Purity"
                  name="selling_purity"
                  value={
                    (() => {
                      const calculatedPurity = calculateSellingPurityForRunningTag();
                      const rateValue = formData.rate || "";
                      
                      if (calculatedPurity && rateValue) {
                        return `${calculatedPurity} (${rateValue})`;
                      } else if (calculatedPurity) {
                        return calculatedPurity;
                      }
                      return formData.custom_purity || formData.selling_purity || "";
                    })()
                  }
                  onChange={handleChange}
                  readOnly
                  disabled={!isToday || fromOrd || isTagEntryProduct}
                />
              ) : (
                <InputField
                  label="Selling Purity"
                  name="selling_purity"
                  type="select"
                  value={formData.selling_purity}
                  onChange={handleChange}
                  disabled={!isToday || fromOrd || isTagEntryProduct}
                  options={[
                    ...(formData.product_name
                      ? [
                          {
                            label:
                              subcategoryOptions.find(
                                (option) => option.value === formData.product_name
                              )?.selling_purity ||
                              formData.selling_purity ||
                              "Default Purity",
                            value:
                              subcategoryOptions.find(
                                (option) => option.value === formData.product_name
                              )?.selling_purity ||
                              formData.selling_purity ||
                              "",
                          },
                        ]
                      : [
                          {
                            label: formData.selling_purity || "Default Purity",
                            value: formData.selling_purity || "",
                          },
                        ]),
                    { label: "Manual", value: "Manual" },
                  ]}
                />
              )}
            </Col>

            {!isRunningTag && formData.selling_purity === "Manual" && (
              <Col xs={12} md={2}>
                <InputField
                  label="Custom Purity %"
                  name="custom_purity"
                  value={formData.custom_purity || ""}
                  onChange={handleChange}
                  disabled={!isToday || fromOrd || isTagEntryProduct}
                />
              </Col>
            )}

            <Col xs={12} md={1}>
              <InputField
                label="Gross Wt"
                name="gross_weight"
                type="number"
                value={formData.gross_weight || ""}
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={1}>
              <InputField
                label="Stone Wt"
                name="stone_weight"
                type="number"
                value={formData.stone_weight || ""}
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={1}>
              <InputField
                label="St Price"
                name="stone_price"
                type="number"
                value={formData.stone_price || ""}
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={1}>
              <InputField
                label="Weight BW"
                name="weight_bw"
                value={formData.weight_bw == 0.0 ? "" : formData.weight_bw}
                onChange={handleChange}
                readOnly
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>

            <Col xs={12} md={2}>
              <InputField
                label="Wastage On"
                name="va_on"
                type="select"
                value={formData.va_on || ""} // Default to "Gross Weight"
                onChange={handleChange}
                options={[
                  { value: "Gross Weight", label: "Gross Weight" },
                  { value: "Weight BW", label: "Weight BW" },
                  ...(formData.va_on &&
                  !["Gross Weight", "Weight BW"].includes(formData.va_on)
                    ? [{ value: formData.va_on, label: formData.va_on }]
                    : []),
                ]}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={1}>
              <InputField
                label="Wastage%"
                name="va_percent"
                type="number"
                value={
                  formData.va_percent == 0 ? "" : formData.va_percent || "0"
                }
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={1}>
              <InputField
                label="W.Wt"
                name="wastage_weight"
                value={
                  formData.wastage_weight == 0.0
                    ? ""
                    : formData.wastage_weight || "0.00"
                }
                onChange={handleChange}
                readOnly
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={2}>
              <InputField
                label="Total Weight AW"
                name="total_weight_av"
                value={
                  formData.total_weight_av == 0.0
                    ? ""
                    : formData.total_weight_av || ""
                }
                onChange={handleChange}
                readOnly
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>

            <Col xs={12} md={1}>
              <InputField
                label="Rate"
                name="rate"
                type="number"
                value={formData.rate}
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            {/* <Col xs={12} md={1}>
              <InputField
                label="24K Rate"
                name="rate_24k"
                type='number'
                value={formData.rate_24k}
                onChange={handleChange}
              />
            </Col> */}
            <Col xs={12} md={1}>
              <InputField
                label="Amount"
                name="rate_amt"
                value={
                  formData.rate_amt == 0.0 ? "" : formData.rate_amt || "0.00"
                } // Default to "0.00" if undefined
                onChange={handleChange} // Trigger recalculation of Total MC
                readOnly={true} // Ensure it's editable
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={2}>
              <InputField
                label="MC On"
                name="mc_on"
                type="select"
                value={formData.mc_on || ""}
                onChange={handleChange}
                options={[
                  { value: "MC / Gram", label: "MC / Gram" },
                  { value: "MC / Piece", label: "MC / Piece" },
                  { value: "MC %", label: "MC %" },
                  ...(formData.mc_on &&
                  !["MC / Gram", "MC / Piece", "MC %"].includes(formData.mc_on)
                    ? [{ value: formData.mc_on, label: formData.mc_on }]
                    : []),
                ]}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>

            <Col xs={12} md={1}>
              <InputField
                label={formData.mc_on === "MC %" ? "MC %" : "MC/Gm"}
                name="mc_per_gram"
                type="number"
                value={formData.mc_per_gram || ""}
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
                readOnly={formData.mc_on === "MC / Piece"} // Only disable when MC / Piece is selected
              />
            </Col>
            {/* <Col xs={12} md={1}>
              <InputField
                label={formData.mc_on === "MC %" ? "MC %" : "MC/Gm"}
                name="mc_per_gram"
                type="number"
                value={
                  formData.mc_per_gram !== "" && formData.mc_per_gram !== null
                    ? parseFloat(formData.mc_per_gram).toFixed(2)
                    : ""
                }
                onChange={handleChange}
                readOnly={formData.mc_on === "MC / Piece"}
              />
            </Col> */}
            <Col xs={12} md={1}>
              <InputField
                label="Total MC"
                name="making_charges"
                type="number"
                value={
                  formData.making_charges == 0.0
                    ? ""
                    : formData.making_charges || ""
                }
                onChange={handleChange}
                disabled={formData.mc_on === "MC / Gram" || !isToday || fromOrd || isTagEntryProduct} // Disable when MC / Gram is selected
              />
            </Col>

            {/* <Col xs={12} md={2}>
              <InputField
                label="Disscount %"
                name="disscount_percentage"
                value={formData.disscount_percentage || ""} // Display calculated Total MC
                onChange={handleChange}
              />
            </Col>

            <Col xs={12} md={2}>
              <InputField
                label="Total Disscount"
                name="disscount"
                value={formData.disscount || ""} // Display calculated Total MC
                onChange={handleChange}
              />
            </Col> */}
            {/* <Col xs={12} md={1}>
              <InputField
                label="Qty"
                name="qty"
                value={formData.qty}
                onChange={handleChange}
                readOnly={!isQtyEditable}
              />
            </Col> */}
            <Col xs={12} md={1}>
              <InputField
                label="HM Charge"
                name="hm_charges"
                type="number"
                disabled={!isToday || fromOrd || isTagEntryProduct}
                value={formData.hm_charges || "0.00"} // Default to "0.00" if undefined
                onChange={handleChange} // Optional, since it's auto-calculated
              />
            </Col>
            <Col xs={12} md={1}>
              <InputField
                label="Tax%"
                name="tax_percent"
                value={formData.tax_percent}
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>
            <Col xs={12} md={1}>
              <InputField
                label="Tax Amt"
                name="tax_amt"
                disabled={!isToday || fromOrd || isTagEntryProduct}
                value={formData.tax_amt || "0.00"} // Default to "0.00" if undefined
                onChange={handleChange} // Optional, since it's auto-calculated
                readOnly
              />
            </Col>
            <Col xs={10} md={1}>
              <InputField
                label="Total Price"
                name="total_price"
                value={formData.total_price ?? ""}
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
              />
            </Col>

            <Col xs={2} md={1} className="d-flex align-items-end">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleTotalPriceChange}
                disabled={!isManualTotalPriceChange || isTagEntryProduct}
                style={{
                  backgroundColor: "#a36e29",
                  borderColor: "#a36e29",
                  padding: "4px 7px",
                  marginBottom: "15px",
                  marginLeft: "-1px",
                  fontSize: "13px",
                }}
              >
                Change
              </button>
            </Col>

            <Col xs={12} md={1}>
              <InputField
                label="Remarks"
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
              />
            </Col>
            <Col xs={12} md={2}>
              <InputField
                label="Visibility"
                name="client_visibility"
                value={formData.client_visibility || "Internal Facing"}
                onChange={handleChange}
                disabled={!isToday || fromOrd || isTagEntryProduct}
                type="select"
                options={[
                  { value: "Client Facing", label: "Client Facing" },
                  { value: "Internal Facing", label: "Internal Facing" },
                ]}
              />
            </Col>
            <Col xs={12} md={2}>
              <InputField
                label="Status"
                type="select"
                name="sale_status"
                disabled={!isToday || fromOrd || isTagEntryProduct}
                value={formData.sale_status}
                onChange={handleChange}
                options={[
                  { value: "Delivered", label: "Delivered" },
                  { value: "Not Delivered", label: "Not Delivered" },
                ]}
              />
            </Col>
            {/* <Col xs={12} md={2}>
              <InputField
                label="Upload Image"
                name="image"
                type="file"
                onChange={handleImageChange}
                accept="image/*"
                ref={fileInputRef} // Attach ref to input field
              />
              {formData.imagePreview && (
                <div style={{ position: "relative", display: "inline-block" }}>
                  <img
                    src={formData.imagePreview}
                    alt="Selected"
                    style={{
                      width: "100px",
                      height: "100px",
                      marginTop: "10px",
                      borderRadius: "8px", // Optional: add rounded corners to the image
                    }}
                  />
                  <button
                    type="button"
                    onClick={clearImage}
                    disabled={isTagEntryProduct}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "transparent",
                      border: "none",
                      color: "red",
                      fontSize: "16px",
                      cursor: isTagEntryProduct ? "not-allowed" : "pointer",
                      opacity: isTagEntryProduct ? 0.5 : 1,
                      zIndex: 10,
                    }}
                  >
                    <FaTrash />
                  </button>
                </div>
              )}
            </Col> */}
            <Col xs={12} md={1}>
              <DropdownButton
                id="dropdown-basic-button"
                title="Choose / Capture Image"
                variant="primary"
                size="sm"
                onClick={() => setShowOptions(!showOptions)}
              >
                {showOptions && (
                  <>
                    <Dropdown.Item
                      onClick={() =>
                        fileInputRef.current && fileInputRef.current.click()
                      }
                    >
                      <FaUpload /> Choose Image
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setShowWebcam(true)}>
                      <FaCamera /> Capture Image
                    </Dropdown.Item>
                  </>
                )}
              </DropdownButton>

              {/* Hidden File Input */}
              <input
                type="file"
                name="image"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleImageChange}
              />

              {/* Webcam Section */}
              {showWebcam && (
                <div>
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    width={150}
                    height={150}
                  />
                  <Button
                    type="button"
                    variant="success"
                    size="sm"
                    onClick={captureImage}
                    style={{ marginRight: "5px" }}
                  >
                    Capture
                  </Button>
                  <Button
                    type="button"
                    variant="secondary"
                    size="sm"
                    onClick={() => setShowWebcam(false)}
                  >
                    Cancel
                  </Button>
                </div>
              )}
              {/* Image Preview */}
              {formData.imagePreview && (
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    marginTop: "10px",
                  }}
                >
                  <img
                    src={formData.imagePreview}
                    alt="Selected"
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "8px",
                    }}
                  />
                  <button
                    type="button"
                    onClick={clearImage}
                    disabled={isTagEntryProduct}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "transparent",
                      border: "none",
                      color: "red",
                      fontSize: "16px",
                      cursor: isTagEntryProduct ? "not-allowed" : "pointer",
                      opacity: isTagEntryProduct ? 0.5 : 1,
                      zIndex: 10,
                    }}
                  >
                    <FaTrash />
                  </button>
                </div>
              )}
            </Col>
            <Col xs={12} md={2} ml="10px">
              <div
                className="d-flex flex-row align-items-center"
                style={{ gap: "12px", marginTop: "5px", marginLeft: "100px" }}
              >
                {showTagBalance && (
                  <div
                    className="d-flex flex-row"
                    style={{ gap: "10px", minWidth: "160px" }}
                  >
                    <div style={{ width: "100px" }}>
                      <InputField
                        label="Rem PCS"
                        name="tag_balance_pcs_display"
                        value={
                          formData.tag_balance_pcs !== undefined &&
                          formData.tag_balance_pcs !== null
                            ? formData.tag_balance_pcs
                            : ""
                        }
                        readOnly
                        disabled
                      />
                    </div>
                    <div style={{ width: "90px" }}>
                      <InputField
                        label="Rem Wt"
                        name="tag_balance_weight_display"
                        value={
                          formData.tag_balance_weight !== undefined &&
                          formData.tag_balance_weight !== null
                            ? formData.tag_balance_weight
                            : ""
                        }
                        readOnly
                        disabled
                      />
                    </div>
                  </div>
                )}
                <Button
                  type="button"
                  onClick={
                    isEditing
                      ? handleUpdateWithValidation
                      : handleAddWithValidation
                  }
                  style={{
                    backgroundColor: "#a36e29",
                    borderColor: "#a36e29",
                    padding: "4px 12px",
                    fontSize: "13px",
                  }}
                >
                  {isEditing ? "Update" : "Add"}
                </Button>
                <Button
                  type="button"
                  variant="secondary"
                  onClick={handleClear}
                  style={{
                    backgroundColor: "gray",
                    padding: "4px 12px",
                    fontSize: "13px",
                  }}
                >
                  Clear
                </Button>
                <div style={{ minWidth: "220px", flex: "0 0 220px" }}>
                  <InputField
                    label="Estimate Number"
                    type="select"
                    name="estimate_number"
                    value={formData.estimate_number || selectedEstimate}
                    onChange={handleEstimateChange}
                    disabled={EstimateNo || !isToday || fromOrd || isTagEntryProduct}
                    options={[
                      { value: "", label: "Select Estimate" },
                      ...(selectedEstimate &&
                      !estimate?.some(
                        (item) => item.estimate_number === selectedEstimate
                      )
                        ? [{ value: selectedEstimate, label: selectedEstimate }]
                        : []),
                      ...(estimate || [])
                        .slice()
                        .reverse()
                        .map((item) => ({
                          value: item.estimate_number,
                          label: item.estimate_number,
                        })),
                    ]}
                  />
                </div>
              </div>
            </Col>
          </>
        )}

        <Col xs={6}></Col>

        {/* <Col xs={12} md={2}>
          <InputField
            label="Order Number"
            type="select"
            value={selectedOrder}
            onChange={handleOrderChange}
            options={[
              ...orderData.map((item) => ({
                value: item.order_number,
                label: item.order_number
              }))
            ]}
          />
        </Col> */}
      </Row>
    </Col>
  );
};

export default ProductDetails;
